import { Box, Button, Icon, Typography } from '@material-ui/core';
import styled from 'styled-components';

import { MEDIUM } from '../../core/styles';

export const Title = styled(Typography)`
    font-size: 24px;

    @media (min-width: ${MEDIUM}px) {
        font-size: 32px;
    }
`;

export const ButtonWrapper = styled(Box)`
    display: flex;
    margin-top: 24px;
    align-items: center;
    margin-bottom: 24px;
    flex-direction: column;

    @media (min-width: ${MEDIUM}px) {
        margin-top: 62px;
        margin-bottom: 62px;
        flex-direction: row;
    }
`;

export const ConfirmationButtonWrapper = styled(Box)`
    margin-right: unset;
    margin-bottom: 42px;

    @media (min-width: ${MEDIUM}px) {
        margin-right: 24px;
        margin-bottom: unset;
    }
`;

export const GreenButton = styled(Button).attrs({ variant: 'outlined' })`
    background-color: green;
    color: white;
    &:hover {
        background-color: darkgreen;
    }
`;

export const RedButton = styled(Button).attrs({ variant: 'outlined' })`
    background-color: red;
    color: white;
    &:hover {
        background-color: darkred;
    }
`;

export const ConfirmedIcon = styled(Icon).attrs({
    children: 'check_box'
})`
    color: green;
    margin: 10px;
    font-size: 32px;
`;

export const DeclinedIcon = styled(Icon).attrs({
    children: 'disabled_by_default'
})`
    color: red;
    margin: 10px;
    font-size: 32px;
`;
